import { useIsDesktop } from '~/@mid_ui/layout/useIsDesktop'
import { TabTitleWrapper } from './TabTitleWrapper'
import { WalletAggregates } from './WalletAggregates'
import { HeadingTwo } from '~/@mid_ui/typography/HeadingTwo'

function FinancialOverviewTab() {
  const isDesktop = useIsDesktop()

  return (
    <div className="grow md:pt-5">
      {isDesktop && (
        <TabTitleWrapper>
          <HeadingTwo>Prehľad</HeadingTwo>
        </TabTitleWrapper>
      )}

      <WalletAggregates />
    </div>
  )
}

export { FinancialOverviewTab }
